var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forgot-password"},[_vm._m(0),_c('div',{staticClass:"auth-content"},[_c('notifications',{attrs:{"group":"auth","position":"top center"}}),_c('forgot-password')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-header"},[_c('img',{staticClass:"profile-img-card",attrs:{"id":"profile-img","src":require("../assets/img/main-wratings-logo.png")}})])
}]

export { render, staticRenderFns }